import { StaticAntd } from "./staticAntd";
import { theme as antdTheme, App } from "antd";
import { useEffect, useLayoutEffect } from "react";
import { setupAntdThemeTokensToHtml } from "./setup-antd-theme";

export function AntdApp({ children } = {}) {
    const { token: antdTokens } = antdTheme.useToken();

    useLayoutEffect(() => {
        /* 打印查看支持的 token */
        // console.log("antdTokens", antdTokens);
        setupAntdThemeTokensToHtml(antdTokens);
    }, [antdTokens]);

    return (
        <App className="h-full">
            <StaticAntd />
            {children}
        </App>
    );
}
